(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tab-devices-types', {
            parent: 'entity',
            url: '/tab-devices-types',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevicesTypes.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices-types/tab-devices-types.html',
                    controller: 'TabDevicesTypesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                itemsPerPageChosen: null,
                sort: {
                    value: [],
                    squash: true
                },
                predicates: {},
                search: {
                    value: '',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        predicates: $stateParams.predicates,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevicesTypes');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tab-devices-types-detail', {
            parent: 'tab-devices-types',
            url: '/tab-devices-types/{id}',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevicesTypes.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices-types/tab-devices-types-detail.html',
                    controller: 'TabDevicesTypesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevicesTypes');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TabDevicesTypes', function($stateParams, TabDevicesTypes) {
                    return TabDevicesTypes.get({id : $stateParams.id});
                }]
            }
        })
        .state('tab-devices-types-new', {
            parent: 'tab-devices-types',
            url: '/new',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevicesTypes.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices-types/tab-devices-types-dialog.html',
                    controller: 'TabDevicesTypesDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevicesTypes');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        deviceTypeName: null,
                        deviceTypeDescription: null,
                        isActive: false,
                        isVisibile: false,
                        id: null
                    };
                }
            }
        })
        .state('tab-devices-types-edit', {
            parent: 'tab-devices-types',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevicesTypes.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices-types/tab-devices-types-dialog.html',
                    controller: 'TabDevicesTypesDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevicesTypes');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TabDevicesTypes', function($stateParams, TabDevicesTypes) {
                    return TabDevicesTypes.get({id : $stateParams.id});
                }]
            }
        })
        .state('tab-devices-types.delete', {
            parent: 'tab-devices-types',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_TECH']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-devices-types/tab-devices-types-delete-dialog.html',
                    controller: 'TabDevicesTypesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TabDevicesTypes', function(TabDevicesTypes) {
                            return TabDevicesTypes.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tab-devices-types', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
